import React from 'react'
import DocumentTitle from 'common/components/document-title'
import useEligibilityPaymentMethodCategoryAwareTranslate from 'common/hooks/use-eligibility-payment-method-category-aware-translate'
import useHppContext from 'common/hooks/use-hpp-context'
import useTheme from 'common/hooks/use-theme'

function EligibilityDocumentTitle() {
  const {
    merchant: { name: merchantName }
  } = useHppContext()
  const { issuerName } = useTheme()
  const eligibilityPaymentMethodCategoryAwareTranslate = useEligibilityPaymentMethodCategoryAwareTranslate()

  return (
    <DocumentTitle
      title={eligibilityPaymentMethodCategoryAwareTranslate('eligibility.document_title', {
        merchantName,
        issuerName
      })}
    />
  )
}

export default EligibilityDocumentTitle
